// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"2c156b79","278":"e10a1a03","338":"07218b43","349":"012ee59f","372":"f06bd45f","387":"c9dce308","453":"f6c3a3d3","580":"eefab6d4","598":"e5775a6d","674":"65636e01","705":"53060dcf","934":"43a0005a"}[chunkId] + ".chunk.js";
};